import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class MegaMenuImages extends ThemeComponent {

}
